// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mw-50[data-v-be3fb648] {\n  min-width: 50%;\n}", ""]);
// Exports
module.exports = exports;
